import { Fragment, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button, DatePicker, Input, Modal, Select, Space, Form } from "antd"
import { useForm } from "antd/lib/form/Form"
import { baseAxiosComplete, baseAxiosNoInfo } from "../../../tool/axios"
import _ from 'lodash'

const { Option } = Select

interface Prop {
    checkInID?: string
    onChange?: () => void
}

export default function (prop: Prop) {

    const param: { check_in_id: string } = useParams()

    const [visible, setVisible] = useState<boolean>(false)
    const [form] = useForm()

    const [types, setTypes] = useState<any[]>([])
    const [foods, setFoods] = useState<any[]>([])

    const [foodID1, setFoodID1] = useState<string[]>([])
    const [foodID2, setFoodID2] = useState<string[]>([])

    useEffect(() => {
        baseAxiosNoInfo('/cooking_center/global/food_type_list').then((res: any) => {
            res && setTypes(res)
        })
    }, [])

    const onFinish = () => {
        baseAxiosComplete.post('/cooking_center/customer/dietician_assess/add', {
            check_in_id: param.check_in_id,
            assess_date: form.getFieldValue('assess_date') && form.getFieldValue('assess_date').format('YYYY-MM-DD'),
            guomin_food_item_id: foodID1,
            jinji_food_item_id: foodID2,
            has_shuizhong: form.getFieldValue('has_shuizhong'),
            paibian_status: form.getFieldValue('paibian_status'),
            other_exception: form.getFieldValue('other_exception'),

            before_preg_weight: form.getFieldValue('before_preg_weight'),
            before_born_weight: form.getFieldValue('before_born_weight'),
            current_weight: form.getFieldValue('current_weight'),
            current_height: form.getFieldValue('current_height'),
            has_split: form.getFieldValue('has_split'),

            food_drink_regular: form.getFieldValue('food_drink_regular'),
            taste_flavour: form.getFieldValue('taste_flavour'),
            taste_flavour_desc: form.getFieldValue('taste_flavour_desc'),
            like_sweet: form.getFieldValue('like_sweet'),
            drink_habit: form.getFieldValue('drink_habit'),

            special_food_drink_desc: form.getFieldValue('special_food_drink_desc'),
            food_drink_supply: form.getFieldValue('food_drink_supply'),
            gestation_desc: form.getFieldValue('gestation_desc'),

            stomach_situation: form.getFieldValue('stomach_situation'),
            feed_situation: form.getFieldValue('feed_situation'),
            take_care_needs: form.getFieldValue('take_care_needs'),

            take_care_needs_desc: form.getFieldValue('take_care_needs_desc'),
            summary: form.getFieldValue('summary')
        }).then(res => {
            if (res.status === 0) {
                setVisible(false)
                prop.onChange && prop.onChange()
            }
        })
    }

    return <Fragment>
        <Button type="primary" style={{ marginLeft: 16, marginBottom: 16 }} size="small" onClick={() => { setVisible(true) }}>营养评估</Button>

        {/* 膳食中心 -> 营养膳食 -> 入住客户管理 -> 客户详情 -> 录入营养评估 */}
        <Modal title="录入营养评估" width={750} visible={visible} onCancel={() => { setVisible(false) }} onOk={onFinish}>
            <div>
                <Form form={form}>
                    <Form.Item label="评估日期" name="assess_date" >
                        <DatePicker />
                    </Form.Item>

                    <Form.Item label="孕前体重/kg" name="before_preg_weight">
                        <Input />
                    </Form.Item>

                    <Form.Item label="产前体重/kg" name="before_born_weight">
                        <Input />
                    </Form.Item>

                    <Form.Item label="目前体重/kg" name="current_weight">
                        <Input />
                    </Form.Item>

                    <Form.Item label="身高/cm" name="current_height">
                        <Input />
                    </Form.Item>

                    <Form.Item label="过敏食材"  >
                        <Space>
                            <Select placeholder="选择食材分类" onChange={(v: string) => {
                                baseAxiosNoInfo('/cooking_center/global/food_item_list', {
                                    params: {
                                        food_type_id: v
                                    }
                                }).then(((res: any) => {
                                    res && setFoods(res)
                                }))
                            }}>
                                {types.map((el: any) => <Option key={el.food_type_id} value={el.food_type_id}>{el.food_type_name}</Option>)}
                            </Select>

                            <Select placeholder="选择食材" style={{ minWidth: 150 }} mode="multiple" onChange={(v: string[]) => {
                                setFoodID1(v)
                            }} >
                                {foods.map((el: any) => <Option key={el.food_item_id} value={el.food_item_id}>{el.food_item_name}</Option>)}
                            </Select>
                        </Space>
                    </Form.Item>

                    <Form.Item label="禁忌食材" >
                        <Space>
                            <Select placeholder="选择食材分类" onChange={(v: string) => {
                                baseAxiosNoInfo('/cooking_center/global/food_item_list', {
                                    params: {
                                        food_type_id: v
                                    }
                                }).then(((res: any) => {
                                    res && setFoods(res)
                                }))
                            }}>
                                {types.map((el: any) => <Option key={el.food_type_id} value={el.food_type_id}>{el.food_type_name}</Option>)}
                            </Select>

                            <Select placeholder="选择食材" style={{ minWidth: 150 }} mode="multiple" onChange={(v: string[]) => {
                                setFoodID2(v)
                            }} >
                                {foods.map((el: any) => <Option key={el.food_item_id} value={el.food_item_id}>{el.food_item_name}</Option>)}
                            </Select>
                        </Space>
                    </Form.Item>

                    <Form.Item label="水肿情况" name="has_shuizhong" >
                        <Select >
                            <Option key={1} value={1}>有</Option>
                            <Option key={0} value={0}>无</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="排便情况" name="paibian_status" >
                        <Select >
                            <Option key={0} value={0}>便秘</Option>
                            <Option key={1} value={1}>正常</Option>
                            <Option key={2} value={2}>稀便</Option>
                            <Option key={3} value={3}>腹泻</Option>
                            <Option key={4} value={4}>其他</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="是否撕裂" name="has_split" >
                        <Select>
                            <Option key={0} value={0}>无</Option>
                            <Option key={1} value={1}>一度</Option>
                            <Option key={2} value={2}>二度</Option>
                            <Option key={3} value={3}>三度</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="饮食规律性" name="food_drink_regular" >
                        <Select >
                            <Option key={1} value={1}>定时定量</Option>
                            <Option key={2} value={2}>定时不定量</Option>
                            <Option key={3} value={3}>不定时不定量</Option>
                            <Option key={4} value={4}>严重不规律</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="口味偏好" name="taste_flavour" >
                        <Select mode="multiple" >
                            <Option key={1} value={1}>清淡</Option>
                            <Option key={2} value={2}>酸甜</Option>
                            <Option key={3} value={3}>咸香</Option>
                            <Option key={4} value={4}>香辣</Option>
                            <Option key={5} value={5}>其他</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="喜欢甜食点心" name="like_sweet" >
                        <Select >
                            <Option key={1} value={1}>有</Option>
                            <Option key={0} value={0}>无</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="饮水习惯" name="drink_habit" >
                        <Select >
                            <Option key={1} value={1}>小于1500ml/d</Option>
                            <Option key={2} value={2}>1500-2000ml/d</Option>
                            <Option key={3} value={3}>大于2000ml/d</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="特殊饮食要求" name="special_food_drink_desc">
                        <Input />
                    </Form.Item>

                    <Form.Item label="膳食补充剂" name="food_drink_supply" >
                        <Input />
                    </Form.Item>

                    <Form.Item label="妊娠合并症" name="gestation_desc">
                        <Input />
                    </Form.Item>

                    <Form.Item label="肠胃病史" name="stomach_situation" >
                        <Select >
                            <Option key={0} value={0}>无</Option>
                            <Option key={1} value={1}>胃炎</Option>
                            <Option key={2} value={2}>肠炎</Option>
                            <Option key={3} value={3}>其他</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="喂养情况" name="feed_situation" >
                        <Select >
                            <Option key={1} value={1}>纯母乳</Option>
                            <Option key={2} value={2}>混合喂养 </Option>
                            <Option key={3} value={3}>人工喂养</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="调理需求" name="take_care_needs" >
                        <Select mode="multiple">
                            <Option key={1} value={1}>预防月子病</Option>
                            <Option key={2} value={2}>改善体质 </Option>
                            <Option key={3} value={3}>保持体重</Option>
                            <Option key={4} value={4}>减重</Option>
                            <Option key={5} value={5}>增重</Option>
                            <Option key={7} value={6}>提升乳量</Option>
                            <Option key={8} value={7}>减少乳量</Option>
                            <Option key={9} value={8}>回奶</Option>
                            <Option key={10} value={9}>了解营养知识</Option>
                            <Option key={11} value={10}>其他</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item label="营养评估总结" name="summary">
                        <Input />
                    </Form.Item>

                    <Form.Item label="其他异常/备注" name="other_exception">
                        <Input />
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    </Fragment>
}